var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import useStore from './../store';
import { variables } from './../theme';
import { Button } from 'reactstrap';
import styled from 'styled-components';
var LegendButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: calc(", " + 20px);\n  left: 50%;\n  width: 164px;\n  height: 44px;\n  border-radius: 22px !important;\n  margin-left: -82px;\n  background-color: ", " !important;\n  font-size: 1.4rem !important;\n  font-weight: 400 !important;\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);\n"])), variables.dimensions.navbarHeight, variables.colors.white);
/**
 * Button to toggle map legend display if legend is hidden.
 */

var LegendToggleBtn = function LegendToggleBtn(_ref) {
  var props = _extends({}, _ref); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var showMobileLegend = useStore(function (state) {
    return state.showMobileLegend;
  });
  var activeView = useStore(function (state) {
    return state.activeView;
  }); // Current breakpoint.

  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  });

  var updateLegend = function updateLegend() {
    // console.log('updateLegend()')
    setStoreValues({
      showMobileLegend: true
    });
  };

  if (!showMobileLegend && (breakpoint === 'xs' || breakpoint === 'sm' && activeView === 'explorer')) {
    return /*#__PURE__*/React.createElement(LegendButton, {
      color: "",
      active: true,
      id: "map_legend_toggle",
      className: "map-legend-btn",
      onClick: function onClick() {
        updateLegend();
      },
      "aria-label": i18n.translate("UI_MAP_SEE_LEGEND")
    }, i18n.translate("UI_MAP_SEE_LEGEND"));
  } else {
    return '';
  }
};

export default LegendToggleBtn;